import config from "./config";

const directory = config.ratedolphin.directory;
const rateDolphin = [
    {
        category: "L1D1",
        link: `${config.flashUrl}/${directory}/fe/L1D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L1D2",
        link: `${config.flashUrl}/${directory}/fe/L1D2/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L2D1",
        link: `${config.flashUrl}/${directory}/fe/L2D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L2D2",
        link: `${config.flashUrl}/${directory}/fe/L2D2/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L3D1+D2",
        link: `${config.flashUrl}/${directory}/fe/L3D1+D2/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L3D3",
        link: `${config.flashUrl}/${directory}/fe/L3D3/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L4D1",
        link: `${config.flashUrl}/${directory}/fe/L4D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L4D2",
        link: `${config.flashUrl}/${directory}/fe/L4D2/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L4D3",
        link: `${config.flashUrl}/${directory}/fe/L4D3/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L5D1",
        link: `${config.flashUrl}/${directory}/fe/L5D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L5D2",
        link: `${config.flashUrl}/${directory}/fe/L5D2/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L5D3",
        link: `${config.flashUrl}/${directory}/fe/L5D3/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L6D1",
        link: `${config.flashUrl}/${directory}/fe/L6D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L6D2",
        link: `${config.flashUrl}/${directory}/fe/L6D2/index.html`,
        desc: "Somehow, it doesn't work.",
        target: true
    },
    {
        category: "L7D1",
        link: `${config.flashUrl}/${directory}/fe/L7D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L7D2",
        link: `${config.flashUrl}/${directory}/fe/L7D2/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L8D1",
        link: `${config.flashUrl}/${directory}/fe/L8D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L8D2",
        link: `${config.flashUrl}/${directory}/fe/L8D2/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L9D1",
        link: `${config.flashUrl}/${directory}/fe/L9D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L9D2",
        link: `${config.flashUrl}/${directory}/fe/L9D2/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L10D1",
        link: `${config.flashUrl}/${directory}/fe/L10D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L10D2+D3",
        link: `${config.flashUrl}/${directory}/fe/L10D2+D3/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L11D1",
        link: `${config.flashUrl}/${directory}/fe/L11D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L11D2",
        link: `${config.flashUrl}/${directory}/fe/L11D2/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L12D1",
        link: `${config.flashUrl}/${directory}/fe/L12D1/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L12D2",
        link: `${config.flashUrl}/${directory}/fe/L12D2/index.html`,
        desc: "FE_B1_Han_Similar_Pin",
        target: true
    },
    // tsdx_B1_Han_Similar_Pin
    {
        category: "L1D1",
        link: `${config.flashUrl}/${directory}/tsdx/L1D1/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L1D2",
        link: `${config.flashUrl}/${directory}/tsdx/L1D2/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L2D1",
        link: `${config.flashUrl}/${directory}/tsdx/L2D1/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L2D2",
        link: `${config.flashUrl}/${directory}/tsdx/L2D2/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L3D1",
        link: `${config.flashUrl}/${directory}/tsdx/L3D1/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L3D2",
        link: `${config.flashUrl}/${directory}/tsdx/L3D2/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L4D1",
        link: `${config.flashUrl}/${directory}/tsdx/L4D1/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L4D2",
        link: `${config.flashUrl}/${directory}/tsdx/L4D2/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L5D1",
        link: `${config.flashUrl}/${directory}/tsdx/L5D1/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L5D2",
        link: `${config.flashUrl}/${directory}/tsdx/L5D2/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L6D1",
        link: `${config.flashUrl}/${directory}/tsdx/L6D1/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L6D2",
        link: `${config.flashUrl}/${directory}/tsdx/L6D2/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L7D1",
        link: `${config.flashUrl}/${directory}/tsdx/L7D1/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L7D2",
        link: `${config.flashUrl}/${directory}/tsdx/L7D2/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L8D1",
        link: `${config.flashUrl}/${directory}/tsdx/L8D1/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L8D2",
        link: `${config.flashUrl}/${directory}/tsdx/L8D2/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L9D1",
        link: `${config.flashUrl}/${directory}/tsdx/L9D1/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L9D2",
        link: `${config.flashUrl}/${directory}/tsdx/L9D2/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L10D1",
        link: `${config.flashUrl}/${directory}/tsdx/L10D1/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    },
    {
        category: "L10D2",
        link: `${config.flashUrl}/${directory}/tsdx/L10D2/index.html`,
        desc: "tsdx_B1_Han_Similar_Pin",
        target: true
    }
];

export default rateDolphin;
